import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { getRGBA } from 'utils/color'

const contentMaxWidth = 1366

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: 'auto !important',
    maxWidth: contentMaxWidth,
    margin: 0,
    padding: '1rem 1.25rem',
    backgroundColor: '#FFFFFF',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.875rem',
    borderRadius: '0.5rem',
    boxShadow: '0 0 4px rgba(0, 0, 0, 0.1)',
    overflow: 'hidden',
  },

  headerLine: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  headerTitle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '0.5rem',

    '& h1': {
      fontFamily: 'Nunito',
      fontWeight: '400',
      fontSize: '1rem',
      lineHeight: '1.5rem',
    },
  },

  tableBase: {
    width: '100%',
  },

  tableHeader: {
    '& th': {
      fontFamily: 'Nunito',
      fontWeight: '600',
      fontSize: '0.875rem',
      lineHeight: '2rem',
      textAlign: 'left',
      padding: '1rem',
      borderBottom: `1px solid ${getRGBA('#000000', 0.12)}`,
    },
  },

  tableBody: {
    '& td': {
      fontFamily: 'Nunito',
      fontWeight: '400',
      fontSize: '0.875rem',
      lineHeight: '1.75rem',
      textAlign: 'left',
      padding: '1rem',
      borderBottom: `1px solid ${getRGBA('#000000', 0.12)}`,
    },
  },

  tableNameSize: {
    width: '23%',
    padding: '0.25rem 1rem',
  },

  tableOthersSize: {
    width: '16.67%',
    padding: '0.25rem 1rem',

    '& span': {
      textTransform: 'capitalize',
    },
  },

  tableInfoSize: {
    width: '26%',
    padding: '0.25rem 1rem',

    '& span': {
      textTransform: 'capitalize',
    },
  },

  tableActionSize: {
    width: '1%',
    padding: '0.25rem 1rem',
  },

  tableOpacityRecipeName: {
    color: getRGBA('#0F0F1E', 0.38),
  },
}))

export { useStyles }
